export default __webpack_public_path__ + "static/media/split1.e8bd6d5d.jpg";